import React from "react";
import { DatePicker, ConfigProvider } from "antd";
import dayjs from "dayjs";

import { Colors, Images } from "../../config";

import "./styles.css";

const DefaultDatepicker = ({
  disableprevious = false,
  disabled = false,
  ...props
}) => {
  const date = props?.datevalue ? dayjs(props?.datevalue, "YYYY-MM-DD") : null;

  const disablePastDates = (currentDate) => {
    return currentDate && currentDate.isBefore(new Date(), "day");
  };

  return (
    <ConfigProvider
      theme={{
        components: {
          DatePicker: {
            activeBorderColor: Colors.main,
            activeShadow: "none",
            hoverBorderColor: Colors.main,
            borderRadius: 10,
            // controlHeight: 48,
          },
        },
        token: {
          colorBorder: Colors.main,
          colorPrimary: Colors.main,
        },
      }}
    >
      <DatePicker
        suffixIcon={
          <img src={Images.DatePickerAddApplication} className="h-[1.5em]" />
        }
        value={date}
        className={`w-full ${
          disabled ? "default-datepicker-disabled" : "default-datepicker"
        } `}
        disabledDate={disableprevious ? disablePastDates : null}
        {...props}
      />
    </ConfigProvider>
  );
};

export default DefaultDatepicker;
